<!-- Verifying Text -->
<div *ngIf="verify" class="processing-text">Verifying...</div>

<!-- Micro Products Section -->
<ng-container *ngIf="cart.microProduct || cart?.plan == undefined">
  <div class="wrap-products" *ngIf="cart.items?.length > 0">
    <p class="total-items">
      You have <span class="itemcount">{{ cart.items.length }} Items </span>in your cart
    </p>
    <div *ngFor="let item of cart.items" class="itemwrap">
      <div class="bg-white">
        <div class="cart-item">
          <div class="card-text">
            <h2 class="item-title">
              <span>{{item.product.type == 'IND_REPORT'?item.product.title:(item.product.type == 'FND_REPORT'
               ?item.product.title: item.name.replace('.pdf', ''))}}
              </span>
            </h2>
            <span class="item-desc">{{ item.product.description }}</span>
          </div>
          <span (click)="removeCartOrder(cart._id, item.sku)" class="remove">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09913 0.549795C5.19399 0.360076 5.3879 0.240234 5.60001 0.240234H10.4C10.6121 0.240234 10.806 0.360076 10.9009 0.549795L12.3461 3.44023H14.4C14.7093 3.44023 14.96 3.69095 14.96 4.00023C14.96 4.30951 14.7093 4.56023 14.4 4.56023H13.36V13.6002C13.36 14.1731 13.1324 14.7225 12.7274 15.1276C12.3223 15.5327 11.7729 15.7602 11.2 15.7602H4.80001C4.22714 15.7602 3.67774 15.5327 3.27266 15.1276C2.86758 14.7225 2.64001 14.1731 2.64001 13.6002V4.56023H1.60001C1.29073 4.56023 1.04001 4.30951 1.04001 4.00023C1.04001 3.69095 1.29073 3.44023 1.60001 3.44023H3.65391L5.09913 0.549795ZM3.98787 4.56023C3.99568 4.5604 4.00349 4.5604 4.01129 4.56023H11.9887C11.9965 4.5604 12.0043 4.5604 12.0122 4.56023H12.24V13.6002C12.24 13.8761 12.1304 14.1406 11.9354 14.3356C11.7404 14.5307 11.4758 14.6402 11.2 14.6402H4.80001C4.52418 14.6402 4.25966 14.5307 4.06462 14.3356C3.86958 14.1406 3.76001 13.8761 3.76001 13.6002V4.56023H3.98787ZM11.0939 3.44023H4.90611L5.94611 1.36023H10.0539L11.0939 3.44023ZM6.40001 6.64023C6.70929 6.64023 6.96001 6.89095 6.96001 7.20023V12.0002C6.96001 12.3095 6.70929 12.5602 6.40001 12.5602C6.09073 12.5602 5.84001 12.3095 5.84001 12.0002V7.20023C5.84001 6.89095 6.09073 6.64023 6.40001 6.64023ZM9.60001 6.64023C9.90929 6.64023 10.16 6.89095 10.16 7.20023V12.0002C10.16 12.3095 9.90929 12.5602 9.60001 12.5602C9.29073 12.5602 9.04001 12.3095 9.04001 12.0002V7.20023C9.04001 6.89095 9.29073 6.64023 9.60001 6.64023Z" fill="#900808"/>
            </svg>
          </span>
        </div>
        <div class="card-bottom">
          <div class="text-left price">
            {{ item.price | pricePipe }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- Subscription Plan Section -->
<ng-container *ngIf="!cart.microProduct && cart.plan">
  <div class="wrap-products">
    <p class="total-items">
      You have <span class="itemcount">1 Subscription </span>in your cart
    </p>
    <div class="itemwrap">
      <div class="bg-white">
        <div class="cart-item">
          <div class="card-text">
            <h2 class="item-title">
              {{ getSubscriptionName(cart.plan) }}
            </h2>
            <span class="item-desc">{{ getSubscriptionDescription(cart.plan) }}</span>
          </div>
          <span (click)="removeCartOrder(cart._id, cart.plan)" class="remove">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09913 0.549795C5.19399 0.360076 5.3879 0.240234 5.60001 0.240234H10.4C10.6121 0.240234 10.806 0.360076 10.9009 0.549795L12.3461 3.44023H14.4C14.7093 3.44023 14.96 3.69095 14.96 4.00023C14.96 4.30951 14.7093 4.56023 14.4 4.56023H13.36V13.6002C13.36 14.1731 13.1324 14.7225 12.7274 15.1276C12.3223 15.5327 11.7729 15.7602 11.2 15.7602H4.80001C4.22714 15.7602 3.67774 15.5327 3.27266 15.1276C2.86758 14.7225 2.64001 14.1731 2.64001 13.6002V4.56023H1.60001C1.29073 4.56023 1.04001 4.30951 1.04001 4.00023C1.04001 3.69095 1.29073 3.44023 1.60001 3.44023H3.65391L5.09913 0.549795ZM3.98787 4.56023C3.99568 4.5604 4.00349 4.5604 4.01129 4.56023H11.9887C11.9965 4.5604 12.0043 4.5604 12.0122 4.56023H12.24V13.6002C12.24 13.8761 12.1304 14.1406 11.9354 14.3356C11.7404 14.5307 11.4758 14.6402 11.2 14.6402H4.80001C4.52418 14.6402 4.25966 14.5307 4.06462 14.3356C3.86958 14.1406 3.76001 13.8761 3.76001 13.6002V4.56023H3.98787ZM11.0939 3.44023H4.90611L5.94611 1.36023H10.0539L11.0939 3.44023ZM6.40001 6.64023C6.70929 6.64023 6.96001 6.89095 6.96001 7.20023V12.0002C6.96001 12.3095 6.70929 12.5602 6.40001 12.5602C6.09073 12.5602 5.84001 12.3095 5.84001 12.0002V7.20023C5.84001 6.89095 6.09073 6.64023 6.40001 6.64023ZM9.60001 6.64023C9.90929 6.64023 10.16 6.89095 10.16 7.20023V12.0002C10.16 12.3095 9.90929 12.5602 9.60001 12.5602C9.29073 12.5602 9.04001 12.3095 9.04001 12.0002V7.20023C9.04001 6.89095 9.29073 6.64023 9.60001 6.64023Z" fill="#900808"/>
            </svg>
          </span>
        </div>
        <div class="card-bottom">
          <div class="text-left price">
            {{ cart.planPrice | pricePipe }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>


     